angular.
module("dx.webapp.masterTools").
controller("DxUserMergeRouteController", function userMerge(
	$rootScope,
	$scope,
	$http,
	$location,
	dxDialog,

	UserMergeTypeEnum
) {
	"use strict";
	var self = this;

	var API_URL = "/api/v1/mastertools/usermerge";
	self.UserMergeTypeEnum = UserMergeTypeEnum;

	self.mergeType = null;
	self.sourceUserEmail = null;
	self.destinationUserEmail = null;
	self.organizationId = null;
	self.isProcessing = false;
	self.mergeOverview = null;
	self.error = "";

	self.getMergeOverview = function getMergeOverview() {
		self.isProcessing = true;

		$http.get(API_URL + "/overview", {params: {
			mergeType: self.mergeType,
			sourceUserEmail: self.sourceUserEmail,
			destinationUserEmail: self.destinationUserEmail,
			organizationId: self.organizationId,
		}}).then(function onSuccess(response) {
			self.error = "";
			self.mergeOverview = response.data;
			self.isProcessing = false;
		}, function onFailure(response) {
			self.error = response.data.message;
			self.mergeOverview = null;
			self.isProcessing = false;
		});
	};

	self.mergeUsers = function mergeUsers() {
		self.isProcessing = true;

		$http.post(API_URL, {
			mergeType: self.mergeType,
			sourceUserEmail: self.sourceUserEmail,
			destinationUserEmail: self.destinationUserEmail,
			organizationId: self.organizationId,
		}).
			then(function onSuccess() {
				self.error = "";
				$rootScope.$broadcast("notification:success", "User " + self.sourceUserEmail +
					" was successfully merged into user " + self.destinationUserEmail);
				resetFormValues();
				self.mergeOverview = null;
				self.isProcessing = false;
			}, function onFailure(response) {
				switch (response.status) {
					case 409: // Conflict
						showConflictInfoModal();
						resetFormValues();
						break;
					default:
						self.error = response.data.message;
						break;
				}
				self.isProcessing = false;
			});
	};

	$scope.$watchGroup(["vm.mergeType", "vm.sourceUserEmail", "vm.destinationUserEmail", "vm.organizationId"],
		function onChange() {
			self.mergeOverview = null;
		});

	$scope.$watch("vm.mergeType", function onMergeTypeChanged() {
		resetFormValues();
	});

	function showConflictInfoModal() {
		dxDialog.confirm({
			actionIsDangerous: false,
			title: "Student merge conflict occurred",
			body: "The merge was mostly successful, however, one or more of the students had issues fully merging " +
				"due to belonging to the same exam; therefore, we could not merge the answers automatically." +
				"<br /><br />" +
				"Please open the merge conflict resolution tool and resolve the conflicts to finalize the merge. More " +
				"details have been sent to you by email.",
			acceptText: "Open conflict resolution",
			acceptCallback: function accept() {
				dxDialog.closeMostRecent();
				$location.url("/master-tools/student-merge");
			},
			rejectText: "Close",
		});
	}

	function resetFormValues() {
		self.sourceUserId = null;
		self.destinationUserId = null;
		self.organizationId = null;
	}
});
